module.exports = "./img/103b0c768d130560a9236b8549280935.png";